// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2c2cR","info":"UpdateTermsInfo_info__vP-37"};